export const ApplicantStatus = Object.freeze({
    DRAFT: 1,
    OPEN: 2,
    SCHEDULE: 3,
    READY_TO_SCHEDULE: 4,
    SHORTLIST: 5,
    READY_FOR_NEXT_ROUND: 6,
    NEED_TO_DISCUSS_WITH_TEAM: 7,
    FOLLOW_UP: 8,
    FINALIZE: 9,
    JOIN_THE_COMPANY: 10,
    SELECTED: 11,
    CLOSE: 12,
    REJECTED: 13,
    MARKED_FOR_FUTURE_OPENING: 14
});

export const STATUS_COLOR_MAP = {
    Draft: "#6B7280",
    Open: "#3B82F6",
    Schedule: "#F97316",
    "Ready to Schedule": "#F97316",
    Shortlist: "#06B6D4",
    "Ready for Next Round": "#0EA5E9",
    "Need to Discuss with Team": "#F59E0B",
    "Follow Up": "#6366F1",
    Finalize: "#22C55E",
    "Join the Company": "#16A34A",
    Selected: "#14B8A6",
    Close: "#6B7280",
    Rejected: "#EF4444",
    "Marked for Future Opening": "#F97316"
};